// extracted by mini-css-extract-plugin
export default {"bold":"styles_bold__jlzJc","metaLine":"styles_metaLine__7O+Fo","strikethrough":"styles_strikethrough__rR5jo","summaryBadge":"styles_summaryBadge__4lCLm"};